/**
 * Types pour le système d'authentification
 */

// Type principal pour représenter un utilisateur
export interface User {
  userId?: number;
  email: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  role?: UserRole;
  firebaseUid?: string;
  createdAt?: string;
  updatedAt?: string;
  isNewUser?: boolean;
  userType?: string;
  profileType?: string;
  // Ajout des coordonnées géographiques pour les fonctionnalités de distance
  latitude?: number;
  longitude?: number;
}

// Types de rôles utilisateur
export type UserRole = 'user' | 'admin' | 'org_admin' | 'staff';

// État d'authentification
export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
  error: Error | null;
  isInitialized: boolean;
  isNewUser: boolean;
}

// Options de connexion
export interface LoginOptions {
  redirectUrl?: string;
  remember?: boolean;
}

// Paramètres d'inscription
export interface RegisterParams {
  email: string;
  password: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  userType?: string;
}

// Réponse d'inscription
export interface RegisterResponse {
  user: User;
  token: string;
}

// Réponse de connexion
export interface LoginResponse {
  user: User;
  token: string;
}

// Erreur d'authentification
export class AuthError extends Error {
  code?: string;
  
  constructor(message: string, code?: string) {
    super(message);
    this.name = 'AuthError';
    this.code = code;
  }
}

// Type pour la mise à jour de la position utilisateur
export interface UserLocation {
  latitude: number;
  longitude: number;
}
